module.exports = __webpack_public_path__ + "static/img/RW964_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RW964_1.png
// module id = Dy+V
// module chunks = 0